
export const setList = (state, provinces) => {
    state.provinces = provinces
    state.loading = false
}


export const setCurrentEntity = (state, province) => {
    state.currentEntity = province
    state.loading = false
}

export const setLoading = (state, loading) => {
    state.loading = loading
}
